import { useTranslation } from 'react-i18next'

const SECTIONS = [
  'acceptance', 'service', 'youtube', 'contentRights',
  'responsibilities', 'ip', 'payment', 'data', 'dmca',
  'warranty', 'liability', 'indemnification', 'termination',
  'dispute', 'changes',
] as const

export default function TermsPage() {
  const { t } = useTranslation()

  return (
    <div className="max-w-[740px] mx-auto px-6 pt-12 pb-24">
      <div className="glass-panel rounded-2xl p-8 md:p-12">
        <h1 className="text-[1.8rem] font-extrabold mb-2">{t('legal.terms.title')}</h1>
        <p className="text-[0.85rem] text-text-muted mb-10">{t('legal.effectiveDate')}</p>

        <div className="flex flex-col gap-8">
          {SECTIONS.map((key) => (
            <section key={key}>
              <h2 className="text-[1.05rem] font-bold mb-2">{t(`legal.terms.${key}.title`)}</h2>
              <p className="text-[0.9rem] text-text-muted leading-relaxed">{t(`legal.terms.${key}.body`)}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  )
}
